import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {DiagnosticsRecord} from '@app/models/diagnostics-record';
import {DiagnosticsService} from '@app/modules/diagnostics/services/diagnostics.service';
import {NgbDateParserFormatter, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {DOCUMENT} from '@angular/common';
import {
    CustomDateParserFormatter
} from '@app/modules/diagnostics/components/diagnostics-report/date-parser-formatter/custom-date-parser-formatter';

@Component({
  selector: 'app-diagnostics-report',
  templateUrl: './diagnostics-report.component.html',
  styleUrls: ['./diagnostics-report.component.css'],
  providers: [
      { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
})
export class DiagnosticsReportComponent implements OnInit, OnDestroy {
  private RESULTS_ON_PAGE: number = 10;
  protected pageReloadInterval: NodeJS.Timeout;
  protected loading: boolean = false;
  protected datePickerModel: NgbDateStruct;

  protected page: number;
  protected time: number;
  protected name: string;

  protected records: DiagnosticsRecord[] = [];
  protected hasMore: boolean = false;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private activatedRoute: ActivatedRoute,
    private diagnosticsService: DiagnosticsService,
    private router: Router,
  ) {}

  public ngOnInit(): void {
    this.pageReloadInterval = setInterval(() => { location.reload(); }, 60000);

    this.document.body.classList.add('report-page');

    this.activatedRoute.queryParams.subscribe((params: Params) => {
        this.page = parseInt(params.page) || undefined;
        this.time = parseInt(params.time) || undefined;
        this.name = params.name;

        if (this.time) {
          const date: Date = new Date(this.time);

          this.datePickerModel = {
              year: date.getFullYear(),
              month: date.getMonth(),
              day: date.getDay()
          };
        }

        this.loading = true;
        this.diagnosticsService.getDiagnosticsRecords(
          this.page || 0,
          this.name || '',
          this.time || 0
        ).subscribe((records: DiagnosticsRecord[]): void => {
          this.records = records;

          //not 100% accurate because there could be exactly RESULTS_ON_PAGE results, but pre-counting creates unnecessary overhead
          this.hasMore = this.records && this.records.length === this.RESULTS_ON_PAGE;
          this.loading = false;
        });
    });
  }

  public ngOnDestroy(): void {
    clearInterval(this.pageReloadInterval);
    this.document.body.classList.remove('report-page');
  }

  protected newer(): void {
    const queryParams: {page?: number; time?: number; name?: string} = {};

    if (this.time) {
        queryParams.time = this.time;
    }
    if (this.name) {
        queryParams.name = this.name;
    }

    if (this.page) {
        queryParams.page = this.page - 1;
    }

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams
    }).then();
  }

  protected older(): void {
    const queryParams: {page?: number; time?: number; name?: string} = {};

    if (this.time) {
        queryParams.time = this.time;
    }
    if (this.name) {
        queryParams.name = this.name;
    }

    queryParams.page = (this.page || 0) + 1;

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams
    }).then();
  }

  protected filterByDate(): void {
    const queryParams: {page?: number; time?: number; name?: string} = {};

    if (this.page) {
      queryParams.page = this.page;
    }
    if (this.name) {
      queryParams.name = this.name;
    }

    queryParams.time = new Date(`${this.datePickerModel.year}/${this.datePickerModel.month}/${this.datePickerModel.day}`).getTime();

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams
    }).then();
  }

  protected clearFilter(): void {
      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: {}
      }).then();
  }
}
